import { ICreditTransactionTableItem } from "fieldpro-tools";

import { ICustomerLocation } from "../subcategories/map/CustomersMap/CustomersMap";
import { ICustomerLegendFE } from "./types";

export interface ICreditState {
  transactions: ICreditTransactionTableItem[];
  count: number;
  isLoading: boolean;
  error: any;
}

export interface ICustomersState {
  subCategorySelected: string;
  allLegends: Record<string, ICustomerLegendFE>;
  customerLocations: Array<ICustomerLocation> | undefined;
  hasMoreCustomers: boolean;
  credit: ICreditState;
}

const initialState: ICustomersState = {
  customerLocations: undefined,
  hasMoreCustomers: false,
  subCategorySelected: "map",
  allLegends: {},
  credit: {
    transactions: [],
    count: 0,
    isLoading: false,
    error: null,
  },
};

export default initialState;
